import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CartRouterModule } from './cart-router.module';
import { CartPageComponent } from './cart-page/cart-page.component';
import { CartCheckoutComponent } from './cart-checkout/cart-checkout.component';
import { OrderSuccessComponent } from './order-success/order-success.component';
import { OrderService } from './order.service';
import { PaySystemService } from './pay-system.service';
import { DeliveryService } from './delivery.service';
import { TouchspinModule } from '../touchspin/touchspin.module';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TouchspinModule,
    CartRouterModule,
    TextMaskModule,
  ],
  declarations: [
    CartPageComponent,
    CartCheckoutComponent,
    OrderSuccessComponent,
  ],
  providers: [
    OrderService,
    PaySystemService,
    DeliveryService,
  ]
})
export class CartModule {}
